import iconTemplate from '~/components/icons/IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Align-Center--Streamline-Flex"
    >
        <desc>
            {'\n    Align Center Streamline Icon: https://streamlinehq.com\n  '}
        </desc>
        <g id="align-center--text-alignment-align-paragraph-centered-formatting-center">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 0.5h13"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2 4.8335h10"
                strokeWidth={1}
            />
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 13.5h13"
                strokeWidth={1}
            />
            <path
                id="Vector_4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2 9.1665h10"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
